// src/pages/DuyurularPage.js
import ResimUpload from "../ResimUpload";
import GlobalStyles from "@mui/material/GlobalStyles";
import { API_BASE } from "../config";


import React, { useMemo, useState, useEffect } from "react";
import {
  List,
  Datagrid,
  BooleanField,
  Edit,
  Create,
  EditButton,
  SimpleForm,
  TextInput,
  DateInput,
  BooleanInput,
  TopToolbar,
  CreateButton,
  ExportButton,
  useRecordContext,
  useRefresh,
  useNotify,
  useRedirect,
  Toolbar,
  SaveButton,
  ImageField,
  TextField,
  SelectInput,
  // ⬇️ Edit'i DuyuruCard gibi yapmak için gerekenler
  EditBase,
  useEditContext,
  useUpdate,
} from "react-admin";
import { useWatch, useFormContext } from "react-hook-form";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  AddCircle as AddCircleIcon,
  FileDownload as FileDownloadIcon,
} from "@mui/icons-material";

const PLACEHOLDER = "Bu dilde içerik mevcut değildir.";
const ALLOWED = ["tr", "en", "de"];

/* --- UI TEXTS --- */
const T = {
  tr: {
    listTitle: "📢 Duyurular",
    newBtn: "Yeni Duyuru",
    exportBtn: "Dışa Aktar",
save: "Kaydet",
    saving: "Kaydediliyor…",
    cancel: "Vazgeç",
    editTitle: "Duyuru Düzenle",
    updatedOk: "✅ Güncelleme başarılı",
"uploadImage": "Görsel Yükle",

    image: "Resim",
    title: "Başlık",
    link: "Link",
    status: "Durum",
    contentLang: "İçerik Dili",
    edit: "Düzenle",
    delete: "Sil",
    confirmDelete: "Silmek istediğinize emin misiniz?",
    editTitle: "🖊️ Duyuruyu Düzenle",
    createTitle: "➕ Yeni Duyuru Ekle",
    updatedOk: "✅ Duyuru güncellendi",
    createdOk: "✅ Duyuru başarıyla oluşturuldu",
    linkLbl: "🔗 Link (https://...)",
    imageUrl: "🖼️ Görsel URL",
    langField: "🌐 İçerik Dili (tr/en/de)",
    date: "📅 Tarih",
    activeQ: "✅ Aktif mi?",
    trTitle: "🇹🇷 Başlık (Türkçe)",
    enTitle: "🇬🇧 Title (İngilizce)",
    deTitle: "🇩🇪 Titel (Almanca)",
    trDesc: "🇹🇷 Açıklama (Türkçe)",
    enDesc: "🇬🇧 Description (İngilizce)",
    deDesc: "🇩🇪 Beschreibung (Almanca)",
    emptyTitle: "Slaytlar için duyuru eklemeye hoş geldiniz",
    emptyDesc:
      "Buraya ekleyeceğiniz görseller ve metinler ana sayfanızdaki slayt bölümünde yayınlanacaktır.",
    emptyBtn: "Hemen Duyuru Ekle",
    langNames: { tr: "Türkçe", en: "İngilizce", de: "Almanca" },
    changeImage: "Değiştir",
    contentLangShort: "İçerik Dili",
    active: "Aktif",
    passive: "Pasif",
  },
  en: {
    listTitle: "📢 Announcements",
    newBtn: "New Announcement",
    exportBtn: "Export",
    image: "Image",
    title: "Title",

save: "Save",
    saving: "Saving…",
    cancel: "Cancel",
    editTitle: "Edit Announcement",
    updatedOk: "✅ Update successful",
  "uploadImage": "Upload Image",

    link: "Link",
    status: "Status",
    contentLang: "Content Language",
    edit: "Edit",
    delete: "Delete",
    confirmDelete: "Are you sure you want to delete?",
    editTitle: "🖊️ Edit Announcement",
    createTitle: "➕ Create Announcement",
    updatedOk: "✅ Announcement updated",
    createdOk: "✅ Announcement created",
    linkLbl: "🔗 Link (https://...)",
    imageUrl: "🖼️ Image URL",
    langField: "🌐 Content Language (tr/en/de)",
    date: "📅 Date",
    activeQ: "✅ Active?",
    trTitle: "🇹🇷 Title (Turkish)",
    enTitle: "🇬🇧 Title (English)",
    deTitle: "🇩🇪 Title (German)",
    trDesc: "🇹🇷 Description (Turkish)",
    enDesc: "🇬🇧 Description (English)",
    deDesc: "🇩🇪 Description (German)",
    emptyTitle: "Welcome to your homepage slider",
    emptyDesc:
      "Items you add here will appear in the slider section of your homepage.",
    emptyBtn: "Add Announcement",
    langNames: { tr: "Turkish", en: "English", de: "German" },
    changeImage: "Change",
    contentLangShort: "Content Language",
    active: "Active",
    passive: "Inactive",
  },
  de: {
    listTitle: "📢 Mitteilungen",
    newBtn: "Neue Mitteilung",
    exportBtn: "Exportieren",
    image: "Bild",
    title: "Titel",

save: "Speichern",
    saving: "Wird gespeichert…",
    cancel: "Abbrechen",
    editTitle: "Mitteilung bearbeiten",
    updatedOk: "✅ Erfolgreich aktualisiert",
 "uploadImage": "Bild hochladen",


    link: "Link",
    status: "Status",
    contentLang: "Inhaltssprache",
    edit: "Bearbeiten",
    delete: "Löschen",
    confirmDelete: "Möchten Sie wirklich löschen?",
    editTitle: "🖊️ Mitteilung bearbeiten",
    createTitle: "➕ Mitteilung erstellen",
    updatedOk: "✅ Mitteilung aktualisiert",
    createdOk: "✅ Mitteilung erstellt",
    linkLbl: "🔗 Link (https://...)",
    imageUrl: "🖼️ Bild-URL",
    langField: "🌐 Inhaltssprache (tr/en/de)",
    date: "📅 Datum",
    activeQ: "✅ Aktiv?",
    trTitle: "🇹🇷 Titel (Türkisch)",
    enTitle: "🇬🇧 Titel (Englisch)",
    deTitle: "🇩🇪 Titel (Deutsch)",
    trDesc: "🇹🇷 Beschreibung (Türkisch)",
    enDesc: "🇬🇧 Beschreibung (Englisch)",
    deDesc: "🇩🇪 Beschreibung (Deutsch)",
    emptyTitle: "Willkommen zum Startseiten-Slider",
    emptyDesc:
      "Hier hinzugefügte Elemente erscheinen im Slider-Bereich Ihrer Startseite.",
    emptyBtn: "Mitteilung hinzufügen",
    langNames: { tr: "Türkisch", en: "Englisch", de: "Deutsch" },
    changeImage: "Ändern",
    contentLangShort: "Inhaltssprache",
    active: "Aktiv",
    passive: "Inaktiv",
  },
};

function useUiTexts() {
  const [uiLang, setUiLang] = useState(
    () => (localStorage.getItem("app_lang") || "tr").slice(0, 2).toLowerCase()
  );
  useEffect(() => {
    const sync = () => {
      const l = (localStorage.getItem("app_lang") || "tr")
        .slice(0, 2)
        .toLowerCase();
      setUiLang(ALLOWED.includes(l) ? l : "tr");
    };
    window.addEventListener("app_lang_change", sync);
    window.addEventListener("storage", sync);
    window.addEventListener("focus", sync);
    return () => {
      window.removeEventListener("app_lang_change", sync);
      window.removeEventListener("storage", sync);
      window.removeEventListener("focus", sync);
    };
  }, []);
  return useMemo(() => T[ALLOWED.includes(uiLang) ? uiLang : "tr"], [uiLang]);
}

/* ---------- Actions bar ---------- */
const ListActions = () => {
  const TT = useUiTexts();
  return (
    <TopToolbar
      sx={{ gap: 1.5, px: 0, width: "100%", justifyContent: "flex-end" }}
    >
      <CreateButton
        icon={<AddCircleIcon />}
        label={TT.newBtn}
        sx={{
          px: 3,
          py: 1.35,
          fontSize: "1.05rem",
          fontWeight: 800,
          borderRadius: "6px",
          textTransform: "none",
          letterSpacing: "0.2px",
          bgcolor: "#f59e0b !important",
          color: "#fff !important",
          boxShadow: "0 6px 18px rgba(245,158,11,0.28)",
          "&:hover": { bgcolor: "#d97706 !important" },
        }}
      />
      <ExportButton
        icon={<FileDownloadIcon />}
        label={TT.exportBtn}
        sx={{
          px: 2.25,
          py: 1.1,
          fontSize: "1rem",
          fontWeight: 700,
          borderRadius: "6px",
          textTransform: "none",
          letterSpacing: "0.2px",
          bgcolor: "#2563eb !important",
          color: "#fff !important",
          boxShadow: "0 6px 18px rgba(37,99,235,0.22)",
          "&:hover": { bgcolor: "#1d4ed8 !important" },
        }}
      />
    </TopToolbar>
  );
};

/* ---------- Delete button ---------- */
const CustomDeleteButton = ({ record }) => {
  const TT = useUiTexts();
  const refresh = useRefresh();

  const handleDelete = async () => {
    const confirmed = window.confirm(TT.confirmDelete);
    if (!confirmed) return;
    const token = localStorage.getItem("token");
await fetch(`${API_BASE}/duyurular/${record.id}`, {
  method: "DELETE",
  headers: { Authorization: `Bearer ${token}` },
});

    refresh();
window.location.hash = "#/duyurular";   // ⭐ HATA KAYBOLUR

  };

  return (
    <button
      onClick={handleDelete}
      style={{
        color: "#fff",
        background: "#ef4444",
        border: "1px solid #ef4444",
        borderRadius: 6,
        padding: "6px 10px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        fontWeight: 700,
        fontSize: "0.95rem",
      }}
      title={TT.delete}
    >
      <DeleteIcon fontSize="small" /> {TT.delete}
    </button>
  );
};

const ActionButtons = () => {
  const TT = useUiTexts();
  const record = useRecordContext();
  return (
    <div style={{ display: "flex", gap: "8px", justifyContent: "flex-start" }}>
      <EditButton
        record={record}
        icon={<EditIcon />}
        sx={{
          color: "#fff !important",
          bgcolor: "#f59e0b !important",
          border: "1px solid #f59e0b",
          borderRadius: "6px",
          px: 1.2,
          py: 0.6,
          fontWeight: 800,
          fontSize: "0.95rem",
          textTransform: "none",
          "&:hover": { bgcolor: "#d97706 !important" },
        }}
        label={TT.edit}
      />
      <CustomDeleteButton record={record} />
    </div>
  );
};

const DuyuruEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton
      sx={{
        px: 2.5,
        py: 1.05,
        fontSize: "1rem",
        fontWeight: 800,
        textTransform: "none",
        borderRadius: "8px",
        bgcolor: "#2563eb !important",
        "&:hover": { bgcolor: "#1d4ed8 !important" },
      }}
    />
  </Toolbar>
);

/* ---------- Title cell (smart) ---------- */
const BaslikField = ({ label }) => {
  const record = useRecordContext();
  if (!record) return null;

  const pickValue = (code) =>
    code === "tr"
      ? record.baslik_tr
      : code === "en"
      ? record.baslik_en
      : record.baslik_de;

  const langOrder = [record.dil, "tr", "en", "de"].filter(Boolean);
  let value = "-";
  for (const code of langOrder) {
    const v = pickValue(code);
    if (v && v.trim() && v.trim() !== PLACEHOLDER) {
      value = v;
      break;
    }
  }

  return (
    <span
      style={{
        fontWeight: 800,
        fontSize: "1.02rem",
        color: "#0f172a",
        display: "block",
      }}
      aria-label={label}
      title={value}
    >
      {value}
    </span>
  );
};

/* ---------- Language cell ---------- */
const DilField = ({ label, names }) => {
  const record = useRecordContext();
  if (!record) return null;

  let code = record.dil;
  if (!code) {
    if (record.baslik_tr && record.baslik_tr !== PLACEHOLDER) code = "tr";
    else if (record.baslik_en && record.baslik_en !== PLACEHOLDER) code = "en";
    else if (record.baslik_de && record.baslik_de !== PLACEHOLDER) code = "de";
  }
  const labelText = names[code] || "-";
  return (
    <span
      aria-label={label}
      title={labelText}
      style={{ fontWeight: 700, fontSize: "0.95rem", color: "#334155" }}
    >
      {labelText}
    </span>
  );
};

/* ---------- Empty State ---------- */
const EmptyState = () => {
  const TT = useUiTexts();
  return (
    <div
      style={{
        width: "100%",
        minHeight: "50vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ textAlign: "center", maxWidth: 680, padding: "32px 16px" }}>
        <div
          style={{
            width: 88,
            height: 88,
            borderRadius: 14,
            border: "2px dashed #cbd5e1",
            margin: "0 auto 14px",
            display: "grid",
            placeItems: "center",
            fontSize: 36,
            color: "#94a3b8",
          }}
        >
          🖼️
        </div>
        <h2 style={{ fontSize: 26, fontWeight: 900, margin: 0, color: "#0f172a" }}>
          {TT.emptyTitle}
        </h2>
        <p style={{ fontSize: 16, color: "#475569", marginTop: 10 }}>
          {TT.emptyDesc}
        </p>
        <CreateButton
          label={TT.emptyBtn}
          icon={<AddCircleIcon />}
          sx={{
            mt: 2,
            px: 3,
            py: 1.35,
            fontSize: "1.05rem",
            fontWeight: 800,
            borderRadius: "6px",
            textTransform: "none",
            bgcolor: "#f59e0b !important",
            color: "#fff !important",
            "&:hover": { bgcolor: "#d97706 !important" },
          }}
        />
      </div>
    </div>
  );
};

/* =================== LIST =================== */
export const DuyurularPage = (props) => {
  const TT = useUiTexts();
  return (
    <List
      {...props}
      title={TT.listTitle}
      actions={<ListActions />}
      sort={{ field: "tarih", order: "DESC" }}
      empty={<EmptyState />}
      sx={{
        m: 0,
        p: 0,
        width: "100%",
        maxWidth: "100%",
        "& .RaList-content": { p: 0, m: 0 },
        "& .MuiCard-root": { boxShadow: "none", borderRadius: 0 },
        "& .MuiContainer-root": {
          maxWidth: "100% !important",
          paddingLeft: 0,
          paddingRight: 0,
        },
      }}
    >
      <Datagrid
        rowClick="edit"
        bulkActionButtons={false}
        sx={{
          width: "100%",
          tableLayout: "fixed",
          "& .RaDatagrid-headerCell": {
            fontWeight: 900,
            fontSize: "1rem",
            color: "#0f172a",
            py: 1,
          },
          "& .RaDatagrid-row": {
            py: 0.75,
            "&:hover": { backgroundColor: "#f8fafc" },
          },
          "& .MuiTableCell-root": {
            paddingTop: "8px",
            paddingBottom: "8px",
            paddingLeft: "12px",
            paddingRight: "12px",
            verticalAlign: "middle",
          },
          "& .column-resim": {
            width: 100,
            minWidth: 150,
            maxWidth: 100,
            paddingRight: "15px",
          },
          "& .column-baslik": { width: "28%" },
          "& .column-link": { width: "38%" },
          "& .column-aktif": { width: 90, minWidth: 90 },
          "& .column-lang": { width: 110, minWidth: 110 },
          "& .column-actions": { width: 200, minWidth: 200 },
        }}
      >
             <ImageField
        source="resim"
      label={TT.image}
          className="column-resim"
          sx={{
            "& img": {
              width: 48,
              height: 48,
              objectFit: "cover",
              borderRadius: 6,
              border: "1px solid #e5e7eb",
            },
          }}
        />
        <BaslikField label={TT.title} className="column-baslik" />
        <TextField
       source="link"
          label={TT.link}
          className="column-link"
          sx={{
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontSize: "0.95rem",
            color: "#0f172a",
          }}
        />
        <BooleanField source="aktif" label={TT.status} className="column-aktif" />
     <DilField label={TT.contentLang} names={TT.langNames} className="column-lang" />
        <div className="column-actions">
          <ActionButtons />
        </div>
      </Datagrid>
    </List>
  );
};

/* ===== Dil-uyumlu input grubu (Create için) ===== */
const LangAwareInputs = ({ TT }) => {
  const dil = (useWatch({ name: "dil" }) || "tr").toLowerCase();
  const show = (code) => (dil === code ? "block" : "none");

  return (
    <>
      {/* TR */}
      <div style={{ display: show("tr") }}>
        <TextInput source="baslik_tr" label={TT.trTitle} fullWidth />
        <TextInput
          source="aciklama_tr"
          label={TT.trDesc}
          fullWidth
          multiline
          minRows={4}
        />
      </div>

      {/* EN */}
      <div style={{ display: show("en") }}>
        <TextInput source="baslik_en" label={TT.enTitle} fullWidth />
        <TextInput
          source="aciklama_en"
          label={TT.enDesc}
          fullWidth
          multiline
          minRows={4}
        />
      </div>

      {/* DE */}
      <div style={{ display: show("de") }}>
        <TextInput source="baslik_de" label={TT.deTitle} fullWidth />
        <TextInput
          source="aciklama_de"
          label={TT.deDesc}
          fullWidth
          multiline
          minRows={4}
        />
      </div>
    </>
  );
};

/* ====== Başlık tek alan gibi (Create için) ====== */
const TitleByDil = ({ TT }) => {
  const dil = (useWatch({ name: "dil" }) || "tr").toLowerCase();
  const source =
    dil === "en" ? "baslik_en" : dil === "de" ? "baslik_de" : "baslik_tr";
  return <TextInput source={source} label={TT.title} fullWidth />;
};

/* ====== Açıklama tek alan gibi (Create için) ====== */
const DescByDil = ({ TT }) => {
  const dil = (useWatch({ name: "dil" }) || "tr").toLowerCase();
  const source =
    dil === "en" ? "aciklama_en" : dil === "de" ? "aciklama_de" : "aciklama_tr";
  return (
    <TextInput
      source={source}
      label={TT.trDesc.replace("🇹🇷 ", "").replace(" (Türkçe)", "")}
      fullWidth
      multiline
      minRows={4}
    />
  );
};

/* ====== Resim alanı + upload (Create için) ====== */
const ResimRow = ({ TT }) => {
  const { setValue } = useFormContext();
  const rawUrl = useWatch({ name: "resim" }) || "";
  const [ver, setVer] = React.useState(0);
  const previewUrl = rawUrl
    ? `${rawUrl}${rawUrl.includes("?") ? "&" : "?"}v=${ver}`
    : "";

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "96px 1fr",
        gap: 12,
        alignItems: "center",
      }}
    >
      <div>
        {rawUrl ? (
          <img
            key={previewUrl}
            src={previewUrl}
            alt="preview"
            style={{
              width: 88,
              height: 88,
              objectFit: "cover",
              borderRadius: 10,
              border: "1px solid #e5e7eb",
            }}
          />
        ) : (
          <div
            style={{
              width: 88,
              height: 88,
              borderRadius: 10,
              border: "1px dashed #cbd5e1",
              display: "grid",
              placeItems: "center",
              color: "#94a3b8",
              fontSize: 20,
            }}
          >
            🖼️
          </div>
        )}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 8 }}>
        <TextInput source="resim" label={TT.imageUrl} fullWidth />
        <ResimUpload
          onUpload={(url) => {
            setValue("resim", url, { shouldDirty: true, shouldTouch: true });
            setVer((n) => n + 1);
          }}
        />
      </div>
    </div>
  );
};

/* ---------- UPDATE Payload Normalizer (Edit/transform artık kullanılmıyor ama kalsın) ---------- */
function normalizeUpdate(data, previousData) {
  const merged = { ...previousData, ...data };
  const dil = (merged.dil || "tr").toLowerCase();
  merged.dil = ALLOWED.includes(dil) ? dil : "tr";
  if (typeof merged.aktif === "string") {
    merged.aktif = merged.aktif === "true" || merged.aktif === "1";
  } else {
    merged.aktif = !!merged.aktif;
  }
  if (merged.tarih) {
    const d = new Date(merged.tarih);
    if (!isNaN(d.getTime())) {
      merged.tarih = d.toISOString().slice(0, 10);
    }
  }
  if (merged.resim == null) merged.resim = "";
  const titleKey = dil === "en" ? "baslik_en" : dil === "de" ? "baslik_de" : "baslik_tr";
  const descKey = dil === "en" ? "aciklama_en" : dil === "de" ? "aciklama_de" : "aciklama_tr";
  merged[titleKey] = merged[titleKey] ?? previousData?.[titleKey] ?? "";
  merged[descKey] = merged[descKey] ?? previousData?.[descKey] ?? "";
  ["baslik_tr","baslik_en","baslik_de","aciklama_tr","aciklama_en","aciklama_de"].forEach(k=>{
    if (merged[k] === PLACEHOLDER) merged[k] = "";
  });
  return merged;
}

/* =================== EDIT (DuyuruCard gibi, full-width) =================== */
export const DuyuruEdit = (props) => (
  <EditBase resource="duyurular" {...props}>
    <DuyuruEditView />
  </EditBase>
);

function DuyuruEditView() {
  const TT = useUiTexts();
  const notify = useNotify();
  const redirect = useRedirect();
  const { record, isLoading } = useEditContext();
  const [update, { isLoading: saving }] = useUpdate();

  const [form, setForm] = React.useState({
    baslik_tr: "",
    baslik_en: "",
    baslik_de: "",
    aciklama_tr: "",
    aciklama_en: "",
    aciklama_de: "",
    resim: "",
    link: "",
    aktif: true,
    dil: "tr",
    tarih: "",
  });

  React.useEffect(() => {
    if (!isLoading && record) {
      setForm({
        baslik_tr: record.baslik_tr || "",
        baslik_en: record.baslik_en || "",
        baslik_de: record.baslik_de || "",
        aciklama_tr: record.aciklama_tr || "",
        aciklama_en: record.aciklama_en || "",
        aciklama_de: record.aciklama_de || "",
        resim: record.resim || "",
        link: record.link || "",
        aktif: !!record.aktif,
        dil: ALLOWED.includes((record.dil || "tr").toLowerCase())
          ? (record.dil || "tr").toLowerCase()
          : "tr",
        tarih: record.tarih || "",
      });
    }
  }, [isLoading, record]);

  const onChange = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const onChangeBool = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value === "true" }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!record) return;

    const merged = {
      ...record,
      ...form,
  link: form.link ?? record.link ?? "",   // 🔥 EKLENECEK SATIR
      aktif: !!form.aktif,
      dil: ALLOWED.includes(form.dil) ? form.dil : "tr",
      tarih: form.tarih
        ? new Date(form.tarih).toISOString().slice(0, 10)
        : record.tarih || "",
    };

    // placeholder temizliği
    ["baslik_tr","baslik_en","baslik_de","aciklama_tr","aciklama_en","aciklama_de"].forEach(k=>{
      if (merged[k] === PLACEHOLDER) merged[k] = "";
    });

    update(
      "duyurular",
      { id: record.id, data: merged, previousData: record },
      {
        onSuccess: () => {
          notify(TT.updatedOk, { type: "success" });
          redirect("/duyurular");
        },
        onError: (e) =>
          notify(`❌ Güncelleme hatası: ${e?.message || ""}`, {
            type: "warning",
          }),
      }
    );
  };

  if (isLoading || !record) {
    return <div className="p-6">Yükleniyor…</div>;
  }

  return (
    <div className="w-full">
     

      {/* Form */}
      <form onSubmit={handleSubmit} className="w-full bg-white px-6 py-5 space-y-4">
        {/* Başlık */}
        <div>
          <label className="block font-medium mb-1">{TT.title}</label>
          <input
            name={`baslik_${form.dil}`}
            value={form[`baslik_${form.dil}`] || ""}
            onChange={(e) =>
              setForm((p) => ({ ...p, [`baslik_${form.dil}`]: e.target.value }))
            }
            className="w-full border rounded px-3 py-2"
            required
          />
        </div>

        {/* Resim */}
        <div>
          <label className="block font-medium mb-1">{TT.image}</label>
          <ResimUpload
  label={TT.uploadImage}
  onUpload={(url) => setForm((p) => ({ ...p, resim: url }))}
 />

          {form.resim && (
            <img
              src={form.resim}
              alt="preview"
              className="mt-2 h-24 w-24 object-cover rounded border"
            />
          )}
        </div>

        {/* Açıklama */}
        <div>
          <label className="block font-medium mb-1">{TT.trDesc.replace("🇹🇷 ", "").replace(" (Türkçe)", "")}</label>
          <textarea
            name={`aciklama_${form.dil}`}
            value={form[`aciklama_${form.dil}`] || ""}
            onChange={(e) =>
              setForm((p) => ({
                ...p,
                [`aciklama_${form.dil}`]: e.target.value,
              }))
            }
            className="w-full border rounded px-3 py-2"
            rows={4}
            required
          />
        </div>

        {/* Link */}
        <div>
          <label className="block font-medium mb-1">{TT.linkLbl}</label>
          <input
            name="link"
            value={form.link || ""}
            onChange={onChange}
            className="w-full border rounded px-3 py-2"
          />
        </div>

        {/* İçerik Dili */}
        <div>
          <label className="block font-medium mb-1">{TT.contentLangShort}</label>
          <select
            name="dil"
            value={form.dil}
            onChange={onChange}
            className="w-full border rounded px-3 py-2"
          >
            <option value="tr">{T.tr.langNames.tr}</option>
            <option value="en">{T.tr.langNames.en}</option>
            <option value="de">{T.tr.langNames.de}</option>
          </select>
        </div>

        {/* Durum */}

    {/* Alt aksiyonlar */}
<div className="pt-4 flex items-center gap-3">
  <button
    type="button"
    onClick={() => redirect("/duyurular")}
    className="px-6 py-2 rounded text-white"
    style={{ backgroundColor: "#f59e0b" }} // turuncu
  >
    {TT.cancel}
  </button>
  <button
    type="submit"
    disabled={saving}
    className="px-6 py-2 rounded text-white disabled:opacity-60"
    style={{ backgroundColor: "#2563eb" }} // mavi
  >
    {saving ? TT.saving : TT.save}
  </button>
</div>


      </form>
    </div>
  );
}

/* =================== CREATE =================== */
export const DuyuruCreate = (props) => {
  const TT = useUiTexts();
  const notify = useNotify();
  const redirect = useRedirect();
  const onSuccess = () => {
    notify(TT.createdOk);
    redirect("/duyurular");
  };
  return (
    <Create {...props} title={TT.createTitle} mutationOptions={{ onSuccess }}>
      <SimpleForm
        sx={{
          "& .MuiFormControl-root": { mb: 2 },
          "& .MuiInputBase-root": { borderRadius: "20px" },
          "& .MuiInputBase-input": { paddingTop: "12px", paddingBottom: "12px" },
          "& .MuiFormLabel-root": { fontWeight: 700 },
        }}
      >
        <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "14px" }}>
          <TextInput source="dil" label={TT.langField} fullWidth />
          <LangAwareInputs TT={TT} />

          <TextInput source="resim" label={TT.imageUrl} fullWidth />
          <TextInput source="link" label={TT.linkLbl} fullWidth />
          <DateInput source="tarih" label={TT.date} fullWidth />
          <BooleanInput source="aktif" label={TT.activeQ} />
        </div>
      </SimpleForm>
    </Create>
  );
};
